import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

import EmbarcadorCadastro from "./EmbarcadorCadastro";

// Modal de detalhe do embarcador (PO1-2728) que a Everlog abre a partir da
// lista: o `.modal-align-top` (completado em _modal-everlog.scss) cuida de
// fundo, header, título e close.

// ─── Modal principal ──────────────────────────────────────────────────────────
// Sprint 638: as abas moram em EmbarcadorCadastro (as mesmas da página do
// cadastro do embarcador, com Origens / CDs e Contatos); o modal só embrulha.
const EmbarcadorDetalheModal = ({ embarcadorId, abaInicial, onClose }) => {
  const [nome, setNome] = useState("");

  useEffect(() => {
    setNome("");
  }, [embarcadorId]);

  return (
    <Modal isOpen={!!embarcadorId} toggle={onClose} modalClassName="modal-align-top" fade={false} size="xl">
      <ModalHeader toggle={onClose}>
        <span style={{ display: "block", fontWeight: 600, fontSize: "0.95rem" }}>{nome || "Embarcador"}</span>
      </ModalHeader>
      <ModalBody style={{ padding: "0 1.5rem 1.25rem", minHeight: "300px" }}>
        {embarcadorId ? (
          <EmbarcadorCadastro
            key={embarcadorId}
            embarcadorId={embarcadorId}
            abaInicial={abaInicial}
            onDados={(d) => setNome(d ? d.fantasia || d.razaoSocial || "" : "")}
          />
        ) : null}
      </ModalBody>
    </Modal>
  );
};

export default EmbarcadorDetalheModal;
